import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { updateMapAtom } from '../atoms'
import React, { ChangeEventHandler, useEffect } from 'react'
import { Box, TextField, Tooltip } from '@mui/material'
import { fieldColumnType } from '../types'
import { keyTest } from '../../../../utility'

export function StringOrNumberDisplay<T extends { id: number }>({
  item,
  columnData: { key: updateKey },
}: {
  item: T
  columnData: { key: string }
}) {
  if (!keyTest(item, updateKey)) return <Box />
  const { [updateKey]: initialValue } = item
  return (
    <Box>
      <Tooltip title={String(initialValue)} enterDelay={500} placement="right">
        <span>{String(initialValue)}</span>
      </Tooltip>
    </Box>
  )
}

export function StringOrNumberEdit<T extends { id: number }>({
  item,
  columnData,
}: {
  item: T
  columnData: fieldColumnType
}) {
  const { key: updateKey, valueType, locked } = columnData
  const [editMap, setEditMap] = useAtom(updateMapAtom)
  const hasKey = keyTest(item, updateKey)
  const initialValue = hasKey ? item[updateKey] : ''

  useEffect(() => {
    setEditMap((prev) => ({
      ...prev,
      [String(updateKey)]: initialValue,
    }))
  }, [setEditMap, updateKey, initialValue])

  if (locked)
    return <StringOrNumberDisplay item={item} columnData={columnData} />

  const onValChange: ChangeEventHandler<HTMLInputElement> = ({
    target: { value },
  }) => {
    const parsedValue = !value
      ? ''
      : valueType === 'string'
        ? value
        : parseInt(value)
    setEditMap((prev) => ({ ...prev, [updateKey]: parsedValue }))
  }

  return (
    <TextField
      label={String(initialValue)}
      value={editMap[String(updateKey)] ?? initialValue}
      onChange={onValChange}
    />
  )
}
